import { saveDesign } from '../../api/designBuilder';
import Item from '../../models/Item';
import Container from '../../models/Container';
import Estimate from '../../models/Estimate';

const createEstimate = (newDesignName) => {
  const estimate = new Estimate(newDesignName);

  const container = new Container();
  container.charLabel = 'A';
  estimate.addContainer(container);

  const item = new Item();
  container.addItem(item);

  return {
    estimate,
    container,
    item,
  };
};

export default (newDesignName) => {
  const payload = createEstimate(newDesignName);
  const { estimate, container, item } = payload;

  return saveDesign({ estimate, containers: [container], items: [item] });
};
